import React, { PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router';

import { RequireAuth } from '@/App';
import useUser from '@/hooks/useUser';
import Sidebar from '@/components/admin/AdminSidebar';
import { routes } from '@/constants/routes';

import RoutesProvider from '@/context/routes/context';
import LearningContentsProvider from '@/context/contents/context';
import StagesProvider from '@/context/stages/context';

const RequireAdminRole: React.FC<PropsWithChildren> = ({ children }) => {
  const { user } = useUser();

  if (!user) {
    return <p>Loading ...</p>;
  }

  if (user?.role !== 'ADMIN') {
    return <Navigate to={routes.welcome} />;
  }

  return <>{children}</>;
};

const AdminLayout = () => {
  return (
    <RequireAuth>
      <RequireAdminRole>
        <RoutesProvider>
          <StagesProvider>
            <LearningContentsProvider>
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  position: 'relative',
                  flexDirection: 'row',
                }}
              >
                <Sidebar />
                <main
                  style={{
                    width: '1280px',
                    display: 'flex',
                    marginInline: 'auto',
                    flexDirection: 'column',
                  }}
                >
                  <Outlet />
                </main>
              </div>
            </LearningContentsProvider>
          </StagesProvider>
        </RoutesProvider>
      </RequireAdminRole>
    </RequireAuth>
  );
};

export default AdminLayout;
